import {
    Box,
    Button,
    Container,
    Flex,
    FormControl,
    FormLabel,
    Image,
    Text,
    Textarea,
    useToast
} from "@chakra-ui/react";
import { partial } from "filesize";
import { useEffect, useState } from 'react';
import { HiArrowNarrowLeft } from "react-icons/hi";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../../components/common/Loading";
import { IQuizQuestionTheory } from "../../../models/assignments/quiz-question.model";
import trainerAssignmentService from "../../../services/trainer/trainer-assignment.service";
export default function AnswerTheoryTrainee() {
    const navigate = useNavigate();
    const toast = useToast();
    const [filetype, setFiletype] = useState<string | undefined>('')
    const [batchFile, setbatchFile] = useState<File | undefined>()
    const [uploadFileSize, setUploadFileSize] = useState('');
    const [value, setValue] = useState('1')
    const [filename, setFilename] = useState('')
    const { course_id } = useParams();
    const [questionHeaderRes, setquestionHeaderRes] = useState<any>();
    const [loading, setLoading] = useState(true);
    const [questions, setQuestions] = useState<IQuizQuestionTheory[]>([
        {
            question_header_id: '',
            question_id: '',
            answer_is_file: '',
            answer: '',
        },
    ]);


    const handleChangeTopic = (
        index: number,
        field: keyof IQuizQuestionTheory,
        field2: keyof IQuizQuestionTheory,
        field3: keyof IQuizQuestionTheory,
        value2: boolean,
        value: string,
        id: string | undefined
    ) => {
        setQuestions((prevTopic) => {
            const updatedTopic = [...prevTopic];
            updatedTopic[index][field] = value;
            updatedTopic[index][field2] = value2;
            updatedTopic[index][field3] = id;
            return updatedTopic;
        });
    };

    const handleAddTopic = () => {
        setQuestions((prevTopic) => [
            ...prevTopic,
            {
                question_header_id: '',
                question_id: '',
                answer_is_file: '',
                answer: '',
            },
        ]);
    };
    const submitQuestion = async () => {
        try {
            const submitArray = questions.map(({ question_header_id, question_id, answer_is_file, answer }: IQuizQuestionTheory) =>
                ({ question_header_id, question_id, answer_is_file, answer }))
            const allSubmission: any[] = []
            
            for (let index = 0; index < submitArray.length; index++) {
                const element = submitArray[index];
                const submitTheory = await trainerAssignmentService.submitTheoryQuestion(course_id, element)
                allSubmission.push(submitTheory)
            }
            if (submitArray.length == allSubmission.length) {
                navigate(-1)
                toast({
                    title: "Theory Assessment",
                    description: `Assessment submitted successfully`,
                    status: "success",
                });
            }

        } catch (error) {
            toast({
                title: "Theory Assessment",
                description: `error`,
                status: "error",
            });
        }
    }

    const handleRemoveTopic = (index: number) => {
        setQuestions((prevTopic) => {
            const updatedTopic = [...prevTopic];
            updatedTopic.splice(index, 1);
            return updatedTopic;
        });
    };

    useEffect(() => {
        const question_header = sessionStorage.getItem("ques_head_info");
        
        if (question_header) {
            setquestionHeaderRes(JSON.parse(question_header));
            trainerAssignmentService
                .getAssignmentQuestions(JSON.parse(question_header).uuid)
                .then((res) => {
                    
                    const resdata: IQuizQuestionTheory[] = res.data
                    setQuestions(res.data);


                    setLoading(false);
                });
        }

    }, [questions.length > 0]);

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;

        if (value) {
            const fileName = e.target.files?.item(0)?.name as string;

            const fileType = e.target.files?.item(0)?.type;

            const file = e.target.files?.item(0) as File;
            

            if ((fileType?.split('/').at(0) !== 'image')) {
                //formik.setErrors({ image_file: 'Only Image file format is supported' });
                return;
            } else {
                
                setFilename(fileName);
                setFiletype(fileType);
                setbatchFile(file);
                const fileSize = partial({ base: 2, standard: "jedec" });
                setUploadFileSize(fileSize(file.size));
            }
        }
        else {
            setFilename('');
            setbatchFile(undefined);
        }


    }




    return (
        <>
            {
                loading ? <Loading /> :
                    <Box minHeight="100vh" bg="#F9F8F8" pb={"6rem"} pt={"2rem"}>

                        <Container
                            width={"78%"}
                            maxWidth={"84%"}
                            px={0}
                            pt='20px'
                            right={0}
                            bg="F9F8F8"
                            mx='auto'
                        >

                            <Box
                                mb='20px'
                                display="flex"
                                alignItems="center"
                                border="1px solid #616161"
                                px="5px"
                                py="7px"
                                width="190px"
                                borderRadius="5px"
                                cursor="pointer"
                            >
                                <HiArrowNarrowLeft color="#616161" fontSize="20px" />
                                <Text fontSize="14px" color="#616161" pl="5px" onClick={() => navigate(-1)} fontWeight={700}>
                                    Back to Assignments
                                </Text>
                            </Box>
                            <Box bg='white' px='70px' py='30px'>

                                <Text color='#4E4D4D' fontWeight='600' pb='0px' fontSize='20px'>{questionHeaderRes.title}</Text>
                                <Text color='#4E4D4D' fontWeight='400' pb='8px' fontSize='13px'>{questionHeaderRes.description}</Text>


                                {
                                    questions && questions.length > 0 && questions.map((question, index) => (
                                        <Flex mt={'7px'} key={index} borderBottom='1px solid' borderColor='lightgray'>
                                            <Box width={'500px'}>
                                                <Text fontSize='14px' fontWeight='500' color=' #616161'>{index + 1}.  {question.question}</Text>

                                                <FormControl>
                                                    <FormLabel fontWeight="normal" textTransform={"uppercase"} color="brand.3" fontSize={13}>
                                                        Answer
                                                    </FormLabel>
                                                    <Textarea
                                                        fontSize={12}
                                                        size="sm"
                                                        minH="6rem"
                                                        placeholder="type answer..."
                                                        name="description"
                                                        value={question.answer}
                                                        border={"2px solid"}
                                                        onChange={(event) =>
                                                            handleChangeTopic(
                                                                index,
                                                                "answer",
                                                                'answer_is_file',
                                                                'question_id',
                                                                false,
                                                                event.target.value,
                                                                question.id?.toString()
                                                            )
                                                        }

                                                    />

                                                </FormControl>

                                            </Box>
                                            {
                                                question.file_url && (
                                                    <Box width={'300px'} height={'200px'} marginLeft={"4rem"}>
                                                        <Image width={'200px'} height={'150px'} src={question.file_url} />
                                                    </Box>
                                                )
                                            }
                                        </Flex>
                                    ))
                                }
                                <Flex mt={12} justifyContent="end">
                                    <Button colorScheme="red" type="submit"
                                        size="sm" px={6} fontSize={14} onClick={() => { submitQuestion() }}> SUBMIT</Button>
                                </Flex>
                            </Box>
                        </Container>
                    </Box>
            }
        </>
    );

}
